export default __webpack_public_path__ + "media/Agriculture.9492af0c.svg";